// on document loaded vanilla js
const url = window.location.href;
const baseUrl = window.location.origin;
if (window.giftLevels) {
	document.addEventListener('DOMContentLoaded', function () {
		const isGift = document.querySelector('[is-gift]');
		if (isGift) {
			window.location.href = baseUrl;
		}
	});
} else if (url.includes('/cart')) {
	window.location.href = baseUrl;
	document.addEventListener('DOMContentLoaded', function () {
		window.location.href = baseUrl;
	})
}
